/*! Alora Avenue — custom additions (defer-loaded via theme.liquid)
 * - Microsoft Clarity heatmap
 * - Cart-drawer mobile rendering fixes
 * - Light header on hero-pages
 */
(function () {
  'use strict';

  /* ===== Microsoft Clarity ===== */
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src='https://www.clarity.ms/tag/'+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, 'clarity', 'script', 'oij8slx2k6');

  /* ===== Light header på hero-sidor =====
   * Lägger till .alora-hero-page på <body> när första sektion är en hero,
   * så CSS kan targeta korrekt utan att räkna med Atelier's color_scheme. */
  function detectHeroPage() {
    var firstSection = document.querySelector('.page-wrapper > .shopify-section:not(.shopify-section-group-header-group)');
    if (!firstSection) firstSection = document.querySelector('main .shopify-section');
    if (!(firstSection && firstSection.classList.contains('hero-wrapper'))) {
      document.body.classList.remove('alora-hero-page');
      return;
    }
    /* Sätt ljus (cream) header BARA när headern faktiskt ligger ovanpå hero-bilden.
       På sidor där headern sitter i ett eget vitt band ovanför bilden (t.ex.
       /pages/vattentaliga-smycken) skulle cream-texten annars bli osynlig på vitt. */
    var header = document.querySelector('header.header-section') || document.querySelector('header');
    if (!header) return;
    var hr = header.getBoundingClientRect();
    var fr = firstSection.getBoundingClientRect();
    if (hr.bottom > fr.top + 10) {
      document.body.classList.add('alora-hero-page');
    } else {
      document.body.classList.remove('alora-hero-page');
    }
  }
  if (document.readyState !== 'loading') detectHeroPage();
  else document.addEventListener('DOMContentLoaded', detectHeroPage);
  /* Kör om efter full layout (fonter/announcement-bar kan flytta headern) */
  window.addEventListener('load', detectHeroPage);

  /* ===== Script-accent "golden hour" på sommarkollektion-hero ===== */
  var SCRIPT_ACCENTS = [
    { match: 'Bär solen runt halsen', text: 'buongiorno sole' },
    { match: 'Stack:a som du vill', text: 'mix & match', color: '#a85d3a' }
  ];

  function injectScriptAccents() {
    document.querySelectorAll('.hero-wrapper').forEach(function (hero) {
      if (hero.dataset.aloraScriptAdded) return;
      for (var i = 0; i < SCRIPT_ACCENTS.length; i++) {
        var accentConfig = SCRIPT_ACCENTS[i];
        var titleEl = null;
        var candidates = hero.querySelectorAll('h1, h2, h3, h4, h5, h6, .text-block p, [class*="jumbo-text"]');
        for (var j = 0; j < candidates.length; j++) {
          var t = (candidates[j].textContent || '').trim();
          if (t.indexOf(accentConfig.match) === 0 && t.length < 200) {
            titleEl = candidates[j];
            break;
          }
        }
        if (titleEl) {
          hero.dataset.aloraScriptAdded = '1';
          var anchor = titleEl.closest('.text-block') || titleEl;
          var accent = document.createElement('span');
          accent.className = 'alora-script-accent';
          var textNode = document.createElement('span');
          textNode.className = 'alora-script-accent__text';
          textNode.textContent = accentConfig.text;
          if (accentConfig.color) {
            textNode.style.setProperty('color', accentConfig.color, 'important');
            accent.style.setProperty('color', accentConfig.color, 'important');
          }
          if (accentConfig.underline) {
            var ns = 'http://www.w3.org/2000/svg';
            var svg = document.createElementNS(ns, 'svg');
            svg.setAttribute('viewBox', '0 0 200 14');
            svg.setAttribute('preserveAspectRatio', 'none');
            svg.setAttribute('class', 'alora-script-accent__underline');
            svg.setAttribute('aria-hidden', 'true');
            var path = document.createElementNS(ns, 'path');
            path.setAttribute('d', 'M8,8 Q60,4 110,7 T192,6');
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke', '#f4d27a');
            path.setAttribute('stroke-width', '1.8');
            path.setAttribute('stroke-linecap', 'round');
            svg.appendChild(path);
            textNode.appendChild(svg);
          }
          accent.appendChild(textNode);
          anchor.parentNode.insertBefore(accent, anchor);
          break;
        }
      }
    });
  }
  if (document.readyState !== 'loading') injectScriptAccents();
  else document.addEventListener('DOMContentLoaded', injectScriptAccents);
  new MutationObserver(injectScriptAccents).observe(document.body, { childList: true, subtree: true });

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
})();
